<template>
    <section class="user-invite-view">
        <div class="modal-header">
            <h3>Invite User</h3>
            <p class="required-fields">All fields marked with * are required</p>
        </div>
        <app-form 
            ref="inviteForm" 
            :model="user"
            :rules="rules"
            @submit.native.prevent="submit">
            
            <app-alert v-if="error" type="error">
                {{ error }}
            </app-alert>
            <app-form-item label="First Name" prop="first_name">
                <app-input id="first_name" v-model="user.first_name" autofocus/>
            </app-form-item>
            <app-form-item label="Last Name" prop="last_name">
                <app-input id="last_name" v-model="user.last_name"/>
            </app-form-item>
            <app-form-item label="Email" prop="email">
                <app-input 
                    id="email" 
                    v-model="user.email"
                    autocorrect="off" 
                    autocapitalize="off" 
                    spellcheck="false"/>
            </app-form-item>
            <app-form-item label="Role" prop="role_id">
                <app-select 
                    id="role_id"
                    v-model="user.role_id"
                    filterable
                    placeholder="Select">
                    <app-option
                        v-for="item in roles"
                        :key="item.id"
                        :label="item.display_name"
                        :value="item.id"/>
                </app-select>
            </app-form-item>
            <div class="modal-footer">
                <app-button
                    :loading="isSaving"
                    type="primary"
                    native-type="submit"
                    size="large"
                    @click.prevent="submit">Invite</app-button>
            </div>
        </app-form>
    </section>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { first, get } from '@/utilities'
import User from '@/store/models/User'

export default {
    name: 'user-invite',
    props: {
        value: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            user: {
                first_name: '',
                last_name: '',
                email: '',
                role_id: null
            },
            isSaving: false,
            error: null,
            rules: {
                first_name: [
                    {
                        required: true,
                        message: 'Please enter a first name',
                        trigger: 'blur'
                    }
                ],
                email: [
                    {
                        required: true,
                        message: 'Please enter an email',
                        trigger: 'blur'
                    }
                ],
                role_id: [
                    {
                        required: true,
                        message: 'Please enter a role',
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    computed: {
        ...mapState({
            roles: ({ params }) => params.roles
        })
    },
    mounted() {
        this.getParams()
    },
    methods: {
        ...mapActions(['getParams']),
        submit() {
            this.error = null
            this.$refs['inviteForm'].validate(valid => {
                if (valid) {
                    this.invite()
                }
            })
            return false
        },
        invite() {
            this.isSaving = true
            User.$mutate({
                graphql: 'invite',
                variables: this.user
            })
                .then(() => {
                    this.isSaving = false
                    this.$emit('input', false)
                    this.$notify({
                        title: 'Success',
                        message: 'Your invite was sent out successfully!',
                        type: 'success',
                        offset: 75,
                        duration: 2000
                    })
                })
                .catch( (errors) => {
                    this.isSaving = false
                    this.error = get(first(errors), 'message', null)
                })
        }
    }
}
</script>

<style lang="stylus"></style>
